<div class='waiting' [ngClass]="{hidden: !_pushSponsorService.spinner}">
  <mat-spinner diameter="60"></mat-spinner>
</div>

<div class="container">

  <app-header-dialog [iconName]="'settings_remote'">
    Push
  </app-header-dialog>


  <div class='tab-content'>

    <form name="entityForm" [formGroup]='entityForm' autocomplete="off">

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Patrocinador</mat-label>
        <mat-select [errorStateMatcher]="matcher" [formControl]="entityForm.controls.sponsor_id">
          <mat-option *ngFor="let sponsor of allSponsors" [value]="sponsor.id">
            {{ sponsor.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="entityForm.controls.sponsor_id.hasError('required')">
          Selecione um patrocinador
        </mat-error>
      </mat-form-field>

      <mat-form-field class="full-width" appearance="outline">
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.title"
          placeholder="Título" autocomplete="off">
        <mat-error *ngIf="entityForm.controls.title.hasError('required')">
          O Título é obrigatório
        </mat-error>
      </mat-form-field>

      <mat-form-field class="full-width" appearance="outline">
        <textarea class='text-area' matInput [errorStateMatcher]="matcher" placeholder="Texto"
          [formControl]="entityForm.controls.text" autocomplete="off">
                    </textarea>
        <mat-error *ngIf="entityForm.controls.text.hasError('required')">
          O texto é obrigatório
        </mat-error>
      </mat-form-field>

      <mat-form-field class="full-width" appearance="outline">
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.url"
          placeholder="URL" autocomplete="off">
        <mat-error *ngIf="entityForm.controls.url.hasError('required')">
          A URL é obrigatória
        </mat-error>
      </mat-form-field>

      <div style='margin-top:20px;'>
        <div>Agendamento</div>
        <mat-form-field class="date-width" appearance="outline">
          <input matInput [matDatepicker]="picker" placeholder="Data (dd/mm/aaaa)" [errorStateMatcher]="matcher"
            [formControl]="entityForm.controls.date_send">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error *ngIf="entityForm.controls.date_send.hasError('required')">
            Informe uma data para o envio
          </mat-error>
        </mat-form-field>

        <mat-form-field class="date-width" appearance="outline">
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.time_send"
            placeholder="Hora (hh:mm)" autocomplete="off">
          <mat-error *ngIf="entityForm.controls.time_send.hasError('required')">
            Informe uma hora para o envio
          </mat-error>
        </mat-form-field>

      </div>


    </form>
  </div>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

    <!--[disabled]="entityForm.invalid"-->
    <button mat-raised-button (click)='insert()' [disabled]="entityForm.invalid" *ngIf="!isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
    <!-- -->
    <button mat-raised-button (click)='update()' [disabled]="entityForm.invalid"
      *ngIf="isEdit && !entityForm.controls.sent.value">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

  </div>

</div>